/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { formatCurrency } from '@omega-energia/utilities';
import { formatCNPJ, formatCPF, isValidCNPJ } from '@brazilian-utils/brazilian-utils';

function ModalConsumerUnits({ isOpen, onClose, consumerUnitsData, customerName }) {
  const formatDocument = doc => {
    if (!doc) {
      return '--';
    }
    try {
      if (isValidCNPJ(doc)) {
        return formatCNPJ(doc);
      }
      return formatCPF(doc);
    } catch (error) {
      return doc;
    }
  };

  return (
    <Dialog open={isOpen} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography>Unidades Consumidoras - {customerName || 'Cliente'}</Typography>
      </DialogTitle>
      <DialogContent>
        {!consumerUnitsData || consumerUnitsData.length === 0 ? (
          <Box display="flex" justifyContent="center" alignItems="center" style={{ minHeight: '200px' }}>
            <Typography variant="body2">Nenhuma unidade consumidora encontrada</Typography>
          </Box>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: '4px 8px' }}>
                  <Typography variant="caption" style={{ fontWeight: 600, color: '#000' }}>
                    Código
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: '4px 8px' }}>
                  <Typography variant="caption" style={{ fontWeight: 600, color: '#000' }}>
                    Titular
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: '4px 8px' }}>
                  <Typography variant="caption" style={{ fontWeight: 600, color: '#000' }}>
                    CPF/CNPJ
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: '4px 8px' }}>
                  <Typography variant="caption" style={{ fontWeight: 600, color: '#000' }}>
                    Consumo Referência (kWh)
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: '4px 8px' }}>
                  <Typography variant="caption" style={{ fontWeight: 600, color: '#000' }}>
                    Valor
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: '4px 8px' }}>
                  <Typography variant="caption" style={{ fontWeight: 600, color: '#000' }}>
                    Comissão Prévia
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {consumerUnitsData.map((uc, index) => (
                <TableRow key={index}>
                  <TableCell style={{ padding: '4px 8px', whiteSpace: 'nowrap' }}>
                    <Typography variant="caption">{uc.code || '--'}</Typography>
                  </TableCell>
                  <TableCell style={{ padding: '4px 8px', whiteSpace: 'nowrap' }}>
                    <Typography variant="caption">{uc.accountHolder?.name || '--'}</Typography>
                  </TableCell>
                  <TableCell style={{ padding: '4px 8px', whiteSpace: 'nowrap' }}>
                    <Typography variant="caption">
                      {uc.accountHolder?.identificationNumber
                        ? formatDocument(uc.accountHolder.identificationNumber)
                        : '--'}
                    </Typography>
                  </TableCell>
                  <TableCell style={{ padding: '4px 8px', whiteSpace: 'nowrap' }}>
                    <Typography variant="caption">{uc.referenceConsumption || '--'}</Typography>
                  </TableCell>
                  <TableCell style={{ padding: '4px 8px', whiteSpace: 'nowrap' }}>
                    <Typography variant="caption">
                      {uc.amount !== undefined && uc.amount !== null ? formatCurrency(uc.amount) : '--'}
                    </Typography>
                  </TableCell>
                  <TableCell style={{ padding: '4px 8px', whiteSpace: 'nowrap' }}>
                    <Typography variant="caption">
                      {uc.previewAmount !== undefined && uc.previewAmount !== null
                        ? formatCurrency(uc.previewAmount)
                        : '--'}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalConsumerUnits.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  consumerUnitsData: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      amount: PropTypes.number,
      previewAmount: PropTypes.number,
      referenceConsumption: PropTypes.number,
      publicId: PropTypes.string,
      accountHolder: PropTypes.shape({
        name: PropTypes.string,
        identificationNumber: PropTypes.string,
      }),
    }),
  ),
  customerName: PropTypes.string,
};

ModalConsumerUnits.defaultProps = {
  consumerUnitsData: [],
  customerName: '',
};

export default ModalConsumerUnits;
